import { GetAssessmentResult } from "../../../assessments";

export class GetAdminAssessmentResult extends GetAssessmentResult {};